function textImage(){
    jQuery('.block.text-image .image.has-video').click(function(){
        var $this = jQuery(this);

        if(!$this.hasClass('initialized')){
            var iframe = '<iframe src="https://www.youtube.com/embed/'+ $this.attr('data-embed') +'?autoplay=1" width="' + $this.width() + 'px" height="' + $this.height() + 'px" allowfullscreen>';
            $this.html(iframe).addClass('initialized');
        }
    });
}
